module.exports = "<input type=\"radio\" id=\"{{vm.row.id ? vm.row.id : vm.row.aleksMasterTemplateId}}\" ng-model=\"vm.metaData[vm.options.dataSet].selectedProduct\" class=\"tableGridRadioCell__image\" ng-value=\"vm.row.id ? vm.row.id : vm.row.aleksMasterTemplateId\" ng-disabled=\"vm.isDisabled()\">\n<div class =\"tableGridRadioCell__label-wrapper\">\n<label for=\"{{vm.row.id ? vm.row.id : vm.row.aleksMasterTemplateId}}\">{{vm.row.name}}</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridRadioCell/tableGridRadioCell.html
// module id = 450
// module chunks = 1